<template>
	<div class="spDiv">
    <ul class="shipin">
      <li v-for="(item,index) in spsyList" :key="item.ID" class="wow fadeInLeft" :data-wow-delay="index/8+'s'">
        <video id="video" controls="controls">
            <source :src="item.FileUrl" type="video/mp4"/>
        </video>
        <div class="dust"></div>
        <p class="play"><img src="../assets/img/play.png" alt=""></p>
      </li>
    </ul>
    <a v-if="moreLink" class="wow zoomIn" data-wow-delay="0.3s">
    	<router-link :to="moreLink" class="moreBTN"></router-link>
    </a>
	</div>
</template>

<script>
	export default{
		name:'spsy',
		props:{
			spsyList:{
				type:Array,
				default:()=>[]
			},
			moreLink: {
			   type: String,
			   default: ''
			},
		},
		methods:{
			setTimeformat(_data,_format='yyyy-mm-dd'){
				 return _format.replace(/YYYY/i,_data.substr(0,4)).replace(/MM/i,_data.substr(5,2)).replace(/DD/i,_data.substr(8,2))
			},
			hoverRoll(_data){
			  this.item = _data
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/spsy.vue